/**
 * Copyright (c) 2020 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import PropTypes from 'prop-types';
import * as consts from '../../const.js';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Notification from '../common/notification/notification.component';

class ParticipantAddressComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: this.props.currentAddress,
      reason: ''
    };
  }

  // handleParticipantAddressChange :: 'addressCity'|'addressPostalCode'|'addressStreet' -> input event E -> ()
  handleParticipantAddressChange = (element) => (event) => {
    const value = event.target.value;
    const newAddress = { ...this.state.address };
    newAddress[element] = value;
    this.setState(() => ({ address: newAddress }));
  };

  changeReasonHandler = (event) => {
    const value = event.target.value;
    this.setState(() => ({ reason: value }));
  };

  updateParticipantAddress = (e) => {
    e.preventDefault();
    const { address, reason } = this.state;
    const { updateParticipantAddress, participantId } = this.props;
    const payload = {
      addressCity: address.addressCity.trim(),
      addressPostalCode: address.addressPostalCode.trim(),
      addressStreet: address.addressStreet.trim(),
      reason
    };
    updateParticipantAddress(participantId, payload);
  };

  hasEmptyRequiredField = () => {
    const { address, reason } = this.state;
    return (
      reason.trim() === '' ||
      address.addressCity.trim() === '' ||
      address.addressPostalCode.trim() === '' ||
      address.addressStreet.trim() === ''
    );
  };

  render() {
    const { isLoading, error } = this.props;
    const { address, reason } = this.state;
    let errorBody = '';
    if (error) {
      errorBody = (
        <Row>
          <Notification type="error" data={error} />
        </Row>
      );
    }

    return (
      <Form horizontal id="edit-participant-address-form" onSubmit={this.updateParticipantAddress}>
        <Grid id="edit-participant-address-grid" fluid>
          {errorBody}
          <Row>
            <FormGroup controlId="participant-address-city-input">
              <ControlLabel>{consts.CHANGE_ADDRESS_CITY}</ControlLabel>
              <FormControl
                onChange={this.handleParticipantAddressChange('addressCity')}
                required
                maxLength="255"
                value={address.addressCity}
                disabled={isLoading}
              />
            </FormGroup>
            <FormGroup controlId="participant-address-postal-code-input">
              <ControlLabel>{consts.CHANGE_ADDRESS_POSTAL_CODE}</ControlLabel>
              <FormControl
                onChange={this.handleParticipantAddressChange('addressPostalCode')}
                required
                maxLength="255"
                value={address.addressPostalCode}
                disabled={isLoading}
              />
            </FormGroup>
            <FormGroup controlId="participant-address-street-input">
              <ControlLabel>{consts.CHANGE_ADDRESS_STREET}</ControlLabel>
              <FormControl
                onChange={this.handleParticipantAddressChange('addressStreet')}
                required
                maxLength="500"
                value={address.addressStreet}
                disabled={isLoading}
              />
            </FormGroup>
            <FormGroup controlId="reason">
              <ControlLabel>
                {consts.CHANGE_PARTICIPANT_ADDRESS_REASON}
                <span> *</span>
              </ControlLabel>
              <FormControl
                componentClass="textarea"
                value={reason}
                onChange={this.changeReasonHandler}
                required
                disabled={isLoading}
              />
            </FormGroup>
          </Row>
        </Grid>
        <div className="edit-modal-footer">
          <hr className="edit-modal-divider" />
          <Button
            id="edit-participant-address-cancel-button"
            theme="default large-button"
            type="reset"
            disabled={isLoading}
            handleClick={() => {
              this.props.hide();
            }}
            label={consts.CANCEL_BTN}
          />
          <Button
            id="edit-participant-address-save-button"
            theme="active large-button"
            type="submit"
            disabled={isLoading || this.hasEmptyRequiredField()}
            label={consts.SAVE_BTN}
          >
            {isLoading ? <Loading /> : null}
          </Button>
        </div>
      </Form>
    );
  }
}

ParticipantAddressComponent.propTypes = {
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  currentAddress: PropTypes.object.isRequired,
  participantId: PropTypes.number.isRequired,
  updateParticipantAddress: PropTypes.func,
  hide: PropTypes.func
};

export default ParticipantAddressComponent;
